 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML01_TITLE_PA from '@/components/xhtml/01_Title_Pa'
 import XHTML03_DEDICATI from '@/components/xhtml/03_Dedicati'
 import XHTML05_ACKNOWLE from '@/components/xhtml/05_ACKNOWLE'
 import XHTML06_FOREWORD from '@/components/xhtml/06_FOREWORD'
 import XHTML07_INTRODUC from '@/components/xhtml/07_INTRODUC'
 import XHTML08_DESIGN_P from '@/components/xhtml/08_Design_P'
 import XHTML09_SPACE from '@/components/xhtml/09_Space'
 import XHTML10___PROPOR from '@/components/xhtml/10___Propor'
 import XHTML11___PATTER from '@/components/xhtml/11___Patter'
 import XHTML12___LINE_A from '@/components/xhtml/12___Line_a'
 import XHTML13___BALANC from '@/components/xhtml/13___Balanc'
 import XHTML14___COLOR from '@/components/xhtml/14___Color'
 import XHTML15_DESIGN_Y from '@/components/xhtml/15_Design_Y'
 import XHTML16_COLOR from '@/components/xhtml/16_Color'
 import XHTML17___FABRIC from '@/components/xhtml/17___Fabric'
 import XHTML18___DESIGN from '@/components/xhtml/18___Design'
 import XHTML19___DESIGN from '@/components/xhtml/19___Design'
 import XHTML20___TAKE_T from '@/components/xhtml/20___Take_t'
 import XHTML21___USE_OF from '@/components/xhtml/21___Use_of'
 import XHTML22_INTERSEC from '@/components/xhtml/22_Intersec'
 import XHTML23_WEAVE_BA from '@/components/xhtml/23_Weave_Ba'
 import XHTML24_RHYTHM_A from '@/components/xhtml/24_Rhythm_A'
 import XHTML25___USE_OF from '@/components/xhtml/25___Use_of'
 import XHTML26_SUBLIME from '@/components/xhtml/26_Sublime'
 import XHTML27_CLEAR_CU from '@/components/xhtml/27_Clear_Cu'
 import XHTML28_GRAY_PLA from '@/components/xhtml/28_Gray_Pla'
 import XHTML29___USE_OF from '@/components/xhtml/29___Use_of'
 import XHTML30_BRIGHT_F from '@/components/xhtml/30_Bright_F'
 import XHTML31_PEACOCK from '@/components/xhtml/31_Peacock'
 import XHTML32_SEEDPOD_ from '@/components/xhtml/32_Seedpod_'
 import XHTML33___USE_OF from '@/components/xhtml/33___Use_of'
 import XHTML34_FROTHY_N from '@/components/xhtml/34_Frothy_N'
 import XHTML35_BREAK_TH from '@/components/xhtml/35_Break_th'
 import XHTML36_SO_WHAT_ from '@/components/xhtml/36_So_What_'
 import XHTML37_YOUR_TOO from '@/components/xhtml/37_Your_Too'
 import XHTML38_THE_BASI from '@/components/xhtml/38_The_basi'
 import XHTML39___MORE_G from '@/components/xhtml/39___More_g'
 import XHTML40_FINISHIN from '@/components/xhtml/40_Finishin'
 import XHTML41_ASSEMBLI from '@/components/xhtml/41_Assembli'
 import XHTML42___QUILTI from '@/components/xhtml/42___Quilti'
 import XHTML43___BINDIN from '@/components/xhtml/43___Bindin'
 import XHTML44___WASHIN from '@/components/xhtml/44___Washin'
 import XHTML45_APPENDIX from '@/components/xhtml/45_APPENDIX'
 import XHTML46_PATTERNS from '@/components/xhtml/46_PATTERNS'
 import XHTML47_RESOURCE from '@/components/xhtml/47_RESOURCE'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML48_ABOUT_TH from '@/components/xhtml/48_ABOUT_TH'
 import XHTML49_COPYRIGH from '@/components/xhtml/49_Copyrigh'
 import XHTML50_BACK_COV from '@/components/xhtml/50_Back_Cov'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/00_Cover",
 			"name" : "xhtml/00_Cover",
 			"component" : XHTML00_COVER
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/01_Title_Pa",
 			"name" : "xhtml/01_Title_Pa",
 			"component" : XHTML01_TITLE_PA
 		},
 		{
 			"path" : "/xhtml/03_Dedicati",
 			"name" : "xhtml/03_Dedicati",
 			"component" : XHTML03_DEDICATI
 		},
 		{
 			"path" : "/xhtml/05_ACKNOWLE",
 			"name" : "xhtml/05_ACKNOWLE",
 			"component" : XHTML05_ACKNOWLE
 		},
 		{
 			"path" : "/xhtml/06_FOREWORD",
 			"name" : "xhtml/06_FOREWORD",
 			"component" : XHTML06_FOREWORD
 		},
 		{
 			"path" : "/xhtml/07_INTRODUC",
 			"name" : "xhtml/07_INTRODUC",
 			"component" : XHTML07_INTRODUC
 		},
 		{
 			"path" : "/xhtml/08_Design_P",
 			"name" : "xhtml/08_Design_P",
 			"component" : XHTML08_DESIGN_P
 		},
 		{
 			"path" : "/xhtml/09_Space",
 			"name" : "xhtml/09_Space",
 			"component" : XHTML09_SPACE
 		},
 		{
 			"path" : "/xhtml/10___Propor",
 			"name" : "xhtml/10___Propor",
 			"component" : XHTML10___PROPOR
 		},
 		{
 			"path" : "/xhtml/11___Patter",
 			"name" : "xhtml/11___Patter",
 			"component" : XHTML11___PATTER
 		},
 		{
 			"path" : "/xhtml/12___Line_a",
 			"name" : "xhtml/12___Line_a",
 			"component" : XHTML12___LINE_A
 		},
 		{
 			"path" : "/xhtml/13___Balanc",
 			"name" : "xhtml/13___Balanc",
 			"component" : XHTML13___BALANC
 		},
 		{
 			"path" : "/xhtml/14___Color",
 			"name" : "xhtml/14___Color",
 			"component" : XHTML14___COLOR
 		},
 		{
 			"path" : "/xhtml/15_Design_Y",
 			"name" : "xhtml/15_Design_Y",
 			"component" : XHTML15_DESIGN_Y
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js